import React, {useEffect, useState} from 'react'
import Input from '../../components/UI/Input'
import {DatePicker, Divider} from 'antd'
import Button from '../../components/UI/Button'
import {useNavigate, useParams} from 'react-router-dom'
import {
  getJackpotPastPaymentById,
  getJackpotPendingPaymentById,
  saveJackpotPayment
} from '../../services/jackpotPayments'
import {useLoading} from '../../context/LoadingProvider/useLoading'
import {onlyLetters, onlyNumbers, returnOnlyNumbersAsInteger} from '../../utils/formValidation'
import {notificationError} from '../../services/notification'
import {InputMode} from '../../enums/inputTypeEnum'
import CancelButton from '../../components/CancelButton'
import SwitchInput from "../../components/UI/SwitchInput";
import dayjs, {Dayjs} from 'dayjs';
import TextArea from "antd/es/input/TextArea";
import { getBingoConfiguration } from "../../services/bingoConfiguration"

function index() {
  const loading = useLoading()
  const {type, id} = useParams()
  const history = useNavigate()
  const switchOptions = {
    check: 1,
    uncheck: 0,
  }
  const format = 'YYYY-MM-DD';
  const [form, setForm] = useState({
    name: "",
    address: "",
    address2: "",
    addr_zipcode: "",
    addr_city: "",
    addr_state: "",
    addr_country: "",
    identification: "",
    state_of_id: "",
    phone_number: "",
    prize: "",
    prize_time: "",
    location: "",
    email: "",
    bar_affiliation: 0,
    org_affiliation: 0,
    birth_date: "",
    comments: "",
    ssn: "",
  })
  const [orig, setOrig] = useState({
    name: "",
    address: "",
    address2: "",
    addr_zipcode: "",
    addr_city: "",
    addr_state: "",
    addr_country: "",
    identification: "",
    state_of_id: "",
    phone_number: "",
    prize: "",
    prize_time: "",
    location: "",
    email: "",
    bar_affiliation: 0,
    org_affiliation: 0,
    birth_date: "",
    comments: "",
    ssn: "",
  })

  const [shouldDisplaySSNField, setShouldDisplaySSNField] = useState(false)
  const [jackpotPrize, setJackpotPrize] = useState('')

  useEffect(()=> {
    (async() => {
      if(!id) return
      loading.addLoading()
      let minJackpotToDisplaySSN = 0;
      const bingoConfig = await getBingoConfiguration()
      if (bingoConfig) {
        minJackpotToDisplaySSN = bingoConfig.display_ssn ? Number(bingoConfig.display_ssn) * 100 : 0
      } 
      if(type === 'pending') {
        const res = await getJackpotPendingPaymentById({id})
        setForm({
          name: "",
          address: "",
          address2: "",
          addr_zipcode: "",
          addr_city: "",
          addr_state: "",
          addr_country: "USA",
          identification: "",
          state_of_id: "",
          phone_number: "",
          prize: res.prize,
          prize_time: res.prize_time,
          location: res.location,
          email:"",
          bar_affiliation: 0,
          org_affiliation: 0,
          birth_date: "",
          comments: "",
          ssn: ""
        })
        setOrig({
          name: "",
          address: "",
          address2: "",
          addr_zipcode: "",
          addr_city: "",
          addr_state: "",
          addr_country: "USA",
          identification: "",
          state_of_id: "",
          phone_number: "",
          prize: res.prize,
          prize_time: res.prize_time,
          location: res.location,
          email:"",
          bar_affiliation: 0,
          org_affiliation: 0,
          birth_date: "",
          comments: "",
          ssn: ""
        })
        setJackpotPrize(res.prize)
        setShouldDisplaySSNField(returnOnlyNumbersAsInteger(res.prize) > minJackpotToDisplaySSN)
      }
      if(type === 'past') {
        const res = await getJackpotPastPaymentById({id})
        setForm({
          name: res.winner.name,
          address: res.winner.address,
          address2: res.winner.address2,
          addr_zipcode: res.winner.addr_zipcode,
          addr_city: res.winner.addr_city,
          addr_state: res.winner.addr_state,
          addr_country: res.winner.addr_country,
          identification: res.winner.identification,
          state_of_id: res.winner.state_of_id,
          phone_number: res.winner.phone_number,
          prize: res.jackpot_information.prize,
          prize_time: res.jackpot_information.prize_time,
          location: res.jackpot_information.location,
          email:res.winner.email,
          bar_affiliation: res.winner.bar_affiliation,
          org_affiliation: res.winner.org_affiliation,
          birth_date: res.winner.birth_date,
          comments: res.winner.comments,
          ssn: res.winner.ssn
        })
        setOrig({
          name: res.winner.name,
          address: res.winner.address,
          address2: res.winner.address2,
          addr_zipcode: res.winner.addr_zipcode,
          addr_city: res.winner.addr_city,
          addr_state: res.winner.addr_state,
          addr_country: res.winner.addr_country,
          identification: res.winner.identification,
          state_of_id: res.winner.state_of_id,
          phone_number: res.winner.phone_number,
          prize: res.jackpot_information.prize,
          prize_time: res.jackpot_information.prize_time,
          location: res.jackpot_information.location,
          email:res.winner.email,
          bar_affiliation: res.winner.bar_affiliation,
          org_affiliation: res.winner.org_affiliation,
          birth_date: res.winner.birth_date,
          comments: res.winner.comments,
          ssn: res.winner.ssn
        })
        setJackpotPrize(res.jackpot_information.prize)
        setShouldDisplaySSNField(returnOnlyNumbersAsInteger(res.jackpot_information.prize) > minJackpotToDisplaySSN)
      }
      loading.removeLoading()
    })()
  },[])

  const isChanged = () => {
    if(!form.name
      || !form.address
      || !form.addr_zipcode
      || !form.addr_city
      || !form.addr_state
      || !form.addr_country
      || !form.identification
      || !form.state_of_id
      || !form.phone_number
      || (type === 'pending' && !form.email)
      || !form.prize
      || (shouldDisplaySSNField && !form.ssn)
    ) { 
      return true 
    }
    else if (!(form.address === orig.address ||  
            form.address2 === orig.address2 ||  
            form.addr_zipcode === orig.addr_zipcode || 
            form.addr_city === orig.addr_city || 
            form.addr_state === orig.addr_state ||  
            form.addr_country === orig.addr_country || 
            form.name===orig.name ||
            form.identification===orig.identification ||
            form.state_of_id===orig.state_of_id ||
            form.phone_number === orig.phone_number ||
            form.email === orig.email ||
            form.bar_affiliation !== orig.bar_affiliation ||
            form.org_affiliation !== orig.org_affiliation ||
            form.birth_date !== orig.birth_date ||
            form.comments !== orig.comments ||
      (shouldDisplaySSNField && form.ssn === orig.ssn))
      ||
      form.name !== orig.name ||
      form.address !== orig.address ||
      form.address2 !== orig.address2 ||
      form.addr_zipcode !== orig.addr_zipcode ||
      form.addr_city !== orig.addr_city ||
      form.addr_state !== orig.addr_state ||
      form.addr_country !== orig.addr_country ||
      form.identification !== orig.identification ||
      form.state_of_id !== orig.state_of_id ||
      form.phone_number !== orig.phone_number ||
      form.email !== orig.email ||
        form.bar_affiliation !== orig.bar_affiliation ||
        form.org_affiliation !== orig.org_affiliation ||
        form.birth_date !== orig.birth_date ||
        form.comments !== orig.comments ||
      (shouldDisplaySSNField && form.ssn !== orig.ssn)) {
      return false 
    }
    return true

  }

  const onSubmit = async () => {

    if(shouldDisplaySSNField && !form.ssn) return notificationError("SSN field is required")
    if(type === 'pending' && !form.email) return notificationError("Email field is required")
    if(onlyNumbers(form.phone_number).length < 10) return notificationError("Please insert a valid phone")
    loading.addLoading()
    const res = await saveJackpotPayment({
      bingo_jackpot_payroll_id: id,
      ...form
    })
    loading.removeLoading()
    if(res) history('/jackpotspayrolls/list')
  }

  return (
    <div className="jackpot-payment-edit">
      <Divider orientation="left"><strong>Contact info</strong></Divider>
      <Input
        style={{width: '440px'}}
        label='Name *'
        placeholder="Name"
        value={form.name}
        onChange={(e: any) => setForm({...form, name: e.target.value})}
      />
      <Input
          onChange={(e) => setForm({...form, phone_number: e.target.value})}
          style={{width: '440px'}}
          label='Phone*'
          placeholder='(000) 000-0000'
          value={form.phone_number || ''}
          inputMode={InputMode.PHONE}
      />
      <Input
          style={{width: '440px'}}
          label='Street address*'
          placeholder="Street address"
          value={form.address}
          onChange={(e: any) => setForm({...form, address: e.target.value})}
      />
      <Input
          style={{width: '440px'}}
          label='Apt'
          placeholder="Apartment no"
          value={form.address2}
          onChange={(e: any) => setForm({...form, address2: e.target.value})}
      />
      <div className="new-distributor__container__row">
          <Input
            label="City*"
            placeholder="City"
            value={form.addr_city}
            onChange={(e: any) => setForm({...form, addr_city: e.target.value})}
          />
          <Input
            label="State*"
            placeholder="State"
            value={form.addr_state}
            onChange={(e: any) => setForm({...form, addr_state: e.target.value})}
            style={{width: 100}}
          />
          <Input
            label="Country*"
            placeholder="Country"
            value={form.addr_country}
            onChange={(e) => setForm({...form, addr_country: e.target.value})}
            style={{width: 100}}
          />
          <Input
            label="Zipcode*"
            placeholder="Zipcode"
            value={form.addr_zipcode}
            onChange={(e: any) => setForm({...form, addr_zipcode: e.target.value})}
          />
        </div>
      { (type === 'pending') &&
          <Input
              style={{width: '440px'}}
              onChange={(e) => setForm({...form, email: e.target.value})}
              label='Email*'
              value={form.email || ''}
          />
      }
      { (type === 'past') &&
          <Input
              style={{width: '440px'}}
              onChange={(e) => setForm({...form, email: e.target.value})}
              label='Email'
              value={form.email || ''}
          />
      }
      { (type === 'pending') &&
          <div className="input-component">
            <div className="input-component__label">
              Birth Date
            </div>
            <div className="input-component__input">
              <DatePicker
                  format={'MM/DD/YYYY'}
                  placeholder={"MM/DD/YYYY"}
                  allowClear = {true}
                  value={form.birth_date?dayjs(form.birth_date, format):null}
                  onChange={(e: any) => setForm({...form, birth_date: e!=null?e.format('YYYY-MM-DD'):null})}
              />
            </div>
          </div>
      }
      { (type === 'past') &&
          <div className="input-component">
            <div className="input-component__label">
              Birth Date
            </div>
            <div className="input-component__input">
              <DatePicker
                  format={'MM/DD/YYYY'}
                  placeholder={"MM/DD/YYYY"}
                  allowClear = {true}
                  value={form.birth_date?dayjs(form.birth_date, format):null}
                  onChange={(e: any) => setForm({...form, birth_date: e!=null?e.format('YYYY-MM-DD'):null})}
              />
            </div>
          </div>
      }
      <Divider orientation="left"><strong>Identifications</strong></Divider>
      <Input
        style={{width: '440px'}}
        label='Identification *'
        placeholder="Identification"
        value={form.identification}
        onChange={(e: any) => setForm({...form, identification: e.target.value})}
      />
      <Input
          style={{width: '440px'}}
          label='State Issuing Identification *'
          placeholder="State"
          maxLength={50}
          value={form.state_of_id}
          onChange={(e: any) => setForm({...form, state_of_id: e.target.value})}
      />
      { shouldDisplaySSNField &&
        <Input
          style={{width: '440px'}}
          onChange={(e:any) => setForm({...form, ssn: e.target.value})}
          label='SSN*'
          value={form.ssn || ''}
        />
      }
      <Divider orientation="left"><strong>Validations</strong></Divider>
      <SwitchInput
          onChange={(e:number) => setForm({...form, bar_affiliation: e})}
          options={switchOptions}
          label='Is winner a site employee or related to the owner of the site?'
          value={form.bar_affiliation}
      />
      <SwitchInput
          onChange={(e:number) => setForm({...form, org_affiliation: e})}
          options={switchOptions}
          label='Is winner a charity member of a charity employee?'
          value={form.org_affiliation}
      />
      <Divider orientation="left"><strong>Comments</strong></Divider>
      <TextArea
          rows={4}
          value={form.comments}
          onChange={(e: any) => setForm({...form, comments: e.target.value})}
      />

      <Divider orientation="left"></Divider>
      <h3>JACKPOT PRIZE: {jackpotPrize}</h3>
      <div className="jackpot-payment-edit__controls">
        <CancelButton />
        <Button type="primary"
                onClick={() => onSubmit()}
                disabled={isChanged()}
        >
          <p id="save-button">Confirm payment</p>
        </Button>
        <p>* Indicates required fields</p>
      </div>
      <Divider/>
    </div>
  )
}

export default index
